---
de:
  downtime_events:
    auto_notice: Die Stillstandszeiten berücksichtigen nicht den Optimierungsplan für Kraftwerke mit Speicher
    available: Verfügbar
    capacity_impact: Kapazitätsauswirkung
    chart_monthly_heading: Monatliche Gründe für Stillstand
    chart_volume_heading: Produktion und Stillstand
    chart_yearly_heading: Jährliche Gründe für Stillstand
    components:
      control_system: Steuerungssystem
      external_grid: Externes Netz
      fiber_and_communication: Faser und Kommunikation
      foundation: Fundament
      generator: Generator
      hardstand: Hardstand
      high_voltage_system: Hochspannungssystem
      intake: Wasserfassung
      internal_grid: Internes Netz
      inverter: Wechselrichter
      logger: Logger
      module: Modul
      other: Andere
      pyranometer: Pyranometer
      road: Straße
      string: String
      substation: Umspannwerk
      transformer: Transformator
      turbine: Turbine
      waterway: Wasserweg
    create: Erstellen
    deletion_failed: Löschen der Stillstandszeit fehlgeschlagen
    downtime_event: Ausfallzeiten
    edit: Stillstandszeit bearbeiten
    email:
      body:
        contact: Kontaktiere %{name} für weitere Informationen
        info: Eine neue Downtime-Periode ist geplant. Bitte beachten Sie dies bei Ihrem Betrieb dieses Kraftwerks.
    email_to_operator: E-Mail an Betreiber senden
    est_downtime_cost: Geschätzte Ertragsverluste
    est_downtime_hours: Geschätzte Stunden
    est_loss: Est. loss
    est_lost_prod_vol: Geschätzte Energieverluste
    est_revenue: Est. Einnahmen
    est_vol_hr: Erwartete Produktion/Stunde
    filter_out_no_water: Kein Wasser ausblenden
    model_name: Stillstandszeit
    model_name_plural: Stillstandszeiten
    model_name_short: Stillstand
    no-data-text: Keine Daten verfügbar - Kraftwerk auswählen
    no_hours: Betroffene Stunden
    no_match: Die ausgewählten Parameter passen zu keinem Kraftwerk.
    not_specified: Nicht angegeben
    reasons:
      commercial_price: Kommerziell/Preis
      effect_restriction: Effektbeschränkung
      external_grid: Externes Stromnetz
      grid: Externes Stromnetz
      no_water: Kein Wasser
      operational_loss: Betriebsausfall
      overflow: Überlauf
      planned_maintenance: Geplante Wartung
      reservoir: Reservoir
      technical: Technisch
      uncategorized: Nicht zugeordnet
      unplanned_maintenance: Ungeplante Wartung
      water_loss: Wasserverlust
      wind: Wind
    scheduled_downtime_event: Geplante Stillstandszeit
    scheduled_downtime_events_name: Geplante Stillstandszeiten
    scheduled_downtime_for: Geplante Stillstandszeit für
    see_stats: Wählen Sie ein Kraftwerk aus, um Statistiken anzuzeigen
    tab_downtime: Stillstandsereignisse
    tab_environmental_flow: Umweltdurchflussereignisse
    tech_downtime: Technischer Stillstand
    tech_downtime_short: Technischer Stillstand
    unavailable: Unverzichtbar
    verified_event_cannot_be_deleted: Verifizierte Stillstandszeiten können nicht gelöscht werden
    verified_event_change_confirmation: Diese Stillstandszeit wurde verifiziert. Änderungen können Berichte und Berechnungen beeinflussen. Möchten Sie fortfahren?
    water_level: Wasserstand
    water_level_unit: m.ü.M.
    water_loss_downtime: Wasserverlust Stillstand
  environmental_flow:
    actions: Aktionen
    assign_to: Zuweisen an
    avg_flow: Durchschn. Durchfluss
    avg_violation: Durchschn. Verstoß
    comment: Beschreibung
    confirm_delete: Sind Sie sicher, dass Sie dieses Umweltdurchflussereignis löschen möchten?
    confirm_run_detection: Verstoßerkennung für die letzten 30 Tage ausführen? Dies kann einige Minuten dauern.
    corrective_volume: Volumen (l/s) für Korrekturmaßnahme
    create_event: Umweltdurchflussereignis erstellen
    current_image: Aktuelles Bild
    delete_error: Ereignis konnte nicht gelöscht werden. Verifizierte Ereignisse können nicht gelöscht werden.
    detection_job_error: Starten der Verstoßerkennungsaufgabe fehlgeschlagen. Bitte versuchen Sie es erneut.
    detection_job_started: Verstoßerkennungsaufgabe gestartet. Ergebnisse erscheinen in Kürze.
    duration: Dauer
    ends_at: Endzeit
    event: Umweltdurchflussereignis
    event_created: Umweltdurchflussereignis erfolgreich erstellt
    excluded: Ausgeschlossen
    fetch_data_error: Umweltdurchflussdaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.
    fetch_drilldown_error: Drilldown-Daten konnten nicht geladen werden. Bitte versuchen Sie es erneut.
    fetch_error: Umweltdurchflussereignisse konnten nicht geladen werden. Bitte versuchen Sie es erneut.
    fetch_events_error: Umweltdurchflussereignisse konnten nicht geladen werden. Bitte versuchen Sie es erneut.
    fetch_latest_value_error: Aktuellster Sensorwert konnte nicht geladen werden. Bitte versuchen Sie es erneut.
    fetch_threshold_error: Schwellenwertdaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.
    further_corrective_measures: Weitere Korrekturmaßnahmen
    generate_task: Aufgabe generieren
    hide_excluded: Ausgeschlossene ausblenden
    image: Bild
    immediate_measures: Sofortmaßnahmen
    linked_task: Verknüpfte Aufgabe
    min_flow: Min. Durchfluss
    no_responsibles_available: Keine Verantwortlichen verfügbar. Bitte konfigurieren Sie mindestens einen Verantwortlichen für dieses Kraftwerk.
    power_plant: Kraftwerk
    reporter_name: Name des Melders
    run_detection: Verstöße erkennen
    show_excluded: Ausgeschlossene anzeigen
    starts_at: Startzeit
    threshold: Schwelle
    title: Verstöße gegen Umweltdurchfluss
    total_events: Gesamt Ereignisse
    total_hours: Gesamt Stunden
    update_comment_error: Beschreibung konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.
    update_excluded_error: Ausschlussstatus konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.
    update_further_corrective_measures_error: Weitere Korrekturmaßnahmen konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut.
    update_immediate_measures_error: Sofortmaßnahmen konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut.
    update_reporter_name_error: Name des Melders konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.
    update_verification_error: Verifizierungsstatus konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.
    verified: Verifiziert
    view_image: Bild ansehen
    violation_pct: Verstoß %
